import { Box } from '@mui/material';

interface Props {
    total: number;
    current: number;
}

export const ProgressIndicator = ({ total, current }: Props) => {
    return (
        <Box display="flex" justifyContent="center" gap={1} mt={4}>
            {Array.from({ length: total }).map((_, idx) => (
                <Box
                    key={idx}
                    sx={{
                        width: 50,
                        height: 7,
                        borderRadius: '50%',
                        backgroundColor: idx < current ? 'primary.main' : 'grey.400',
                    }}
                />
            ))}
        </Box>
    );
};